import React, { useCallback, useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { tableDataContext } from "../dashboard/context/productData";
import Slider from "react-slick";
import UserNavbar from "./userNavbar";
import UserFooter from "./userFooter";
import VieWDataModal from "./viewDataModal";
import getArrowStyle from "antd/es/style/placementArrow";
import Item from "antd/es/list/Item";
import Expiry from "../components/Regex/expiry.js";

const LandingPage = () => {
  const [search, setSearch] = useState("");
  const [priceSort, setPriceSort] = useState();
  const [sliceData, setSliceData] = useState(12);
  const [fullData, setFullData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [adminFiltered, setAdminFiltered] = useState([]);
  const [vendorNames, setvendorNames] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState();
  const { selectedFilters, filters, setFilters, setSelectedFilters } =
    useContext(tableDataContext);
  const navigate = useNavigate();

  useEffect(() => {
    handleViewAll();
  }, []);

  useEffect(() => {
    selectedSearch();
  }, [selectedFilters]);

  useEffect(() => {
    const uniqueVendors = Array.from(
      new Set(adminFiltered.map((item) => item.vendorName))
    );
    setvendorNames(uniqueVendors);
  }, [fullData]);

  useEffect(() => {
    console.log(selectedVendor);
    if (selectedVendor === "default") {
      if (selectedFilters.length > 0) {
        const filteredResults = adminFiltered.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        setFullData(adminFiltered);
      }
    } else if (selectedVendor) {
      const filteredData = adminFiltered.filter(
        (item) => item.vendorName === selectedVendor
      );
      console.log(selectedFilters);
      if (selectedFilters.length > 0) {
        const filteredResults = filteredData.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        setFullData(filteredData);
      }
    }
  }, [selectedVendor]);

  const handleChangeForSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleRemoveAllFilter = () => {
    if (filters.length > 0) {
      setSelectedFilters([]);
      setFilters([]);
      handleViewAll();
    }
  };

  const selectedSearch = (e) => {
    if (selectedFilters.length === 0) {
      handleViewAll();
    } else {
      if (selectedVendor && selectedVendor != "default") {
        const filteredData = adminFiltered.filter(
          (item) => item.vendorName === selectedVendor
        );
        const filteredResults = filteredData.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        const filteredResults = adminFiltered.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      }
    }
  };

  const handleDeleteSelectedHistory = (product) => {
    console.log(product);
    setSelectedFilters(selectedFilters.filter((item) => item !== product));
    const data = filters.filter((filter) => filter != product);
    setFilters(data);
  };

  const handleSearch = () => {
    try {
      if (!search) {
        return;
      }

      setFilters((prevFilters) => [...prevFilters, search]);
      if (!selectedFilters.includes(search)) {
        setSelectedFilters([...selectedFilters, search]);
      }
    } catch (error) {
      console.error("Error processing search:", error);
    }
  };

  const toggleFilter = (filter) => {
    if (selectedFilters.includes(filter)) {
      const updatedFilters = selectedFilters.filter((item) => item !== filter);
      setSelectedFilters(updatedFilters);
    } else {
      setSelectedFilters([...selectedFilters, filter]);
    }
  };

  const handleFullDataLength = () => {
    const modValue = fullData.length % 12;
    const diff = 12 - modValue;
    const length = fullData.length + diff;
    setSliceData(length);
  };

  const handleViewAll = () => {
    setFullData([]);
    setLoader(true);
    axios
      .get(`${process.env.REACT_APP_API}/non_expired_products`)
      .then((res) => {
        const data = res.data.non_expired_products.filter((p) => p.output);
        console.log(data)
        const structuredData = data.flatMap((item) => {
          try {
            const products = JSON.parse(item.output.output);
            return products.map((product) => ({
              productName: product["Product Name"] || "",
              oldPrice: product["Old Price"] || "",
              currentPrice: product["Current Price"] || "",
              quantity: product["Quantity"] || "",
              discount: product["Discount"] || "",
              pdfName: item.pdf_name || "",
              vendorName: item.vendor_name || "",
              expire_date: item.expire_date || "",
            }));
          } catch (error) {
            console.error(
              `Error parsing JSON for item with pdf_name: ${item.pdf_name}`,
              error
            );
            setLoader(false);
            return [];
          }
        });

        if (selectedVendor && selectedVendor != "default") {
          const filteredResults = structuredData.filter(
            (item) => item.vendorName === selectedVendor
          );
          setFullData(filteredResults);
        } else {
          setFullData(structuredData);
        }
        setLoader(false);
        setAdminFiltered(structuredData);
      })
      .catch((err) => {
        setLoader(false);

        console.error(err);
      });
  };

  return (
    <>
      <UserNavbar />
      <div className="flex-1 pb-6 mt-16 mb-16">
        <div className="flex flex-col pt-4 items-center font-userFont">
          <div className="bg-[#F7F7F7] w-full flex flex-col mb-4 items-center px-auto py-8 space-y-8">
            {/* Search Bar */}
            <div className="search_bar bg-searchbar setting lg:w-2/5 md:w-1/2 w-3/4 flex items-center px-5 py-4 gap-3 rounded-full">
              <input
                type="text"
                name="searchbar"
                value={search}
                onChange={handleChangeForSearch}
                className="bg-white !border-none w-full placeholder-placeholderColor"
                placeholder="Search Here......."
                onKeyDown={handleKeyDown}
              />
              {search && (
                <Icon
                  className="cursor-pointer"
                  onClick={() => {
                    if (selectedFilters.includes(search)) {
                      const updatedFilters = selectedFilters.filter(
                        (item) => item !== search
                      );
                      setSelectedFilters(updatedFilters);

                      if (updatedFilters.length === 0) {
                        handleViewAll();
                      }
                    }
                    setSearch("");
                  }}
                  icon="carbon:close-filled"
                  fontSize={25}
                  color="#E3D0A8"
                />
              )}

              <Icon
                icon="ri:search-line"
                className="cursor-pointer"
                color="#E3D0A8"
                width="20"
                height="20"
                onClick={() => {
                  handleSearch();
                }}
              />
            </div>
          </div>
          {/* Slider Section */}
          {loader ? (
            <div className="flex items-center justify-center h-full w-full mt-4  rounded-full">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="flex lg:flex-row flex-col  w-full lg:justify-between lg:items-center px-4 text-2xl font-bold mt-8">
              <div className="flex lg:flex-row flex-col w-full   items-center">
                <h2 className="lg:w-1/6  lg:mb-0  mx-4 w-full">All Products</h2>
                <div className="flex gap-4 flex-wrap  ">
                  {filters.length > 0 &&
                    Array.from(new Set(filters))
                      .slice(0, 5)
                      .map((filter) => (
                        <div
                          key={filter}
                          className={`flex items-center space-x-4 pl-4 border !border-[#E3D0A8] rounded-full ${
                            selectedFilters.includes(filter)
                              ? "text-white bg-[#E3D0A8]"
                              : "text-[#E3D0A8] bg-white"
                          }`}
                        >
                          <button onClick={() => toggleFilter(filter)}>
                            {filter}
                          </button>
                          <div
                            onClick={() => {
                              handleDeleteSelectedHistory(filter);
                            }}
                            className="cursor-pointer bg-[#E3D0A8] rounded-full"
                          >
                            <Icon
                              icon="oui:cross"
                              fontSize={25}
                              color="white"
                            />
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              <div className="flex justify-end items-center space-x-4 lg:w-1/2 w-full lg:mt-0 mt-4">
                <button
                  className={`bg-[#E3D0A8] p-2.5 text-white text-base !border-[#E3D0A8] !border hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] `}
                  onClick={() => handleRemoveAllFilter()}
                >
                  Remove All Filters
                </button>{" "}
                <select
                  className={` bg-[#E3D0A8] text-white text-base !border-[#E3D0A8] !border  p-2.5 cursor-pointer hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] ${
                    priceSort && priceSort != "default"
                      ? "bg-white !text-[#E3D0A8] !border-[#E3D0A8] !border"
                      : ""
                  }`}
                  onChange={(e) => setPriceSort(e.target.value)}
                  value={priceSort}
                >
                  <option value="default">Sort By Price</option>
                  <option value="lowtohigh">Low to High</option>
                  <option value="hightolow">High to Low</option>
                </select>
                <select
                  id="underline_select"
                  className={` bg-[#E3D0A8] text-white text-base !border-[#E3D0A8] !border   p-2.5 cursor-pointer hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] ${
                    selectedVendor && selectedVendor != "default"
                      ? "bg-white !text-[#E3D0A8]  "
                      : ""
                  }`}
                  value={selectedVendor}
                  onChange={(e) => setSelectedVendor(e.target.value)}
                >
                  <option selected value={"default"}>
                    Default Vendor
                  </option>
                  {vendorNames.map((vendor) => (
                    <option value={vendor} key={vendor}>
                      {vendor}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div className="flex flex-col p-12 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2  xl:grid-cols-3 2xl:grid-cols-4 gap-2 w-full ">
              {(priceSort === "lowtohigh"
                ? [...fullData].sort((a, b) => {
                    const priceA = parseFloat(
                      a.currentPrice?.replace(",", ".") || 0
                    );
                    const priceB = parseFloat(
                      b.currentPrice?.replace(",", ".") || 0
                    );
                    return priceA - priceB;
                  })
                : priceSort === "hightolow"
                ? [...fullData].sort((a, b) => {
                    const priceA = parseFloat(
                      a.currentPrice?.replace(",", ".") || 0
                    );
                    const priceB = parseFloat(
                      b.currentPrice?.replace(",", ".") || 0
                    );
                    return priceB - priceA;
                  })
                : fullData
              )
                .slice(0, sliceData)
                .map((data, index) => {
                  const { desiredDate } = data.pdfName
                    ? Expiry(data.pdfName)
                    : { desiredDate: "N/A" };
                  return (
                    <div
                      className="flex flex-col justify-center items-center text-lg font-bold p-6"
                      key={index}
                    >
                      <div className="relative w-full">
                        <div className="absolute top-8 -right-2 bg-[#E3D0A8] w-14 text-center rounded-t-lg text-red-600 font-bold transform rotate-45 origin-top-right">
                          <p>{data.discount}</p>
                        </div>
                        <div className="flex flex-col justify-around rounded-lg bg-gray-200 border h-40 w-full">
                          <p className="px-4">Deadline: {desiredDate}</p>
                          <div className="tooltip-container">
                            <p className="px-2 text-center overflow-hidden text-ellipsis whitespace-nowrap">
                              {data.productName}
                            </p>
                            <span className="tooltip-text">
                              {data.productName}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col px-4 bg-white w-full">
                        <div>
                          <p>Vendor name: {data.vendorName}</p>
                          <p>Quantity: {data.quantity}</p>
                        </div>
                        <div className="flex flex-wrap justify-between ">
                          {data.oldPrice && (
                            <p>
                              <s>
                                Old Price: {data?.oldPrice?.replace(",", ".")}
                              </s>
                            </p>
                          )}
                          <p>Price: {data?.currentPrice?.replace(",", ".")}</p>
                          <Icon
                            className="cursor-pointer"
                            icon="gridicons:star-outline"
                            fontSize={25}
                            onClick={() => navigate("/signin")}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="flex justify-end  w-full">
              {sliceData > 12 && (
                <button
                  type="button"
                  onClick={() => setSliceData(sliceData - 12)}
                  className="text-black cursor-pointer text-end px-12 hover:underline-offset-1 hover:text-[#E3D0A8] text-xl "
                >
                  Show Less...
                </button>
              )}
              {sliceData < fullData.length && (
                <button
                  type="button"
                  onClick={() => setSliceData(sliceData + 12)}
                  className="text-black cursor-pointer text-end px-12 hover:underline-offset-1 hover:text-[#E3D0A8] text-xl "
                >
                  Show More...
                </button>
              )}
              {sliceData < fullData.length && fullData.length > 12 && (
                <button
                  type="button"
                  onClick={() => handleFullDataLength()}
                  className="text-black cursor-pointer text-end px-12 hover:underline-offset-1 hover:text-[#E3D0A8] text-xl "
                >
                  Show All...
                </button>
              )}
            </div>
          </div>

          {loader && (
            <div className="flex justify-between w-[90%] ">
              <span class="loader"></span>
              <span class="loader"></span>
              <span class="loader"></span>
              <span class="loader"></span>
            </div>
          )}
        </div>
      </div>
      <UserFooter />
    </>
  );
};

export default LandingPage;
